export const STORAGE_TOKEN_KEYS = {
  USER: 'RapidPOS-user',
  AUTH_TOKEN: 'RapidPOS-auth-token',
  REFRESH_TOKEN: 'RapidPOS-refresh-token',
  AUTH_TOKEN_EXPIRATION: 'RapidPOS-auth-token-exp',
  REFRESH_TOKEN_EXPIRATION: 'RapidPOS-refresh-token-exp',
  DEVICE_ID: 'RapidPOS-device-id',
  TWO_FA: 'twofa',
};
